const menuDetails = state => ({
    showFullMenu: state.showFullMenu
});

export default menuDetails;
